import { render, staticRenderFns } from "./LoadingLanguageString.vue?vue&type=template&id=2b989520"
import script from "./LoadingLanguageString.vue?vue&type=script&lang=js"
export * from "./LoadingLanguageString.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports